"use client"
import {
  ContainerPortal
} from "./chunk-DMWOTLFW.mjs";
import {
  DefaultPortal
} from "./chunk-RDVM2NYN.mjs";

// src/portal.tsx
import { jsx } from "react/jsx-runtime";
var Portal = ({
  appendToParentPortal = true,
  children,
  containerRef,
  isDisabled,
  disabled = isDisabled
}) => {
  if (disabled) return children;
  return containerRef ? /* @__PURE__ */ jsx(
    ContainerPortal,
    {
      containerRef,
      ...{ appendToParentPortal, children }
    }
  ) : /* @__PURE__ */ jsx(DefaultPortal, { ...{ appendToParentPortal, children } });
};
Portal.displayName = "Portal";
Portal.__ui__ = "Portal";

export {
  Portal
};
//# sourceMappingURL=chunk-L2QJFRDD.mjs.map